import React from "react";
import {
  Briefcase,
  FileText,
  Sparkles,
  TrendingUp,
  Users,
  Lightbulb,
  ArrowLeft,
  Cpu,
  Network,
  AlertCircle,
  Zap,
} from "lucide-react";
import MainHeader from "../MainHeader";
import { useNavigate } from "react-router-dom";

export default function VirtualBizLabHome() {
  const navigate = useNavigate();
  //   const navigate = (path) => console.log(`Navigate to: ${path}`);

  return (
    <>
      <MainHeader />
      {/* <MainHeader /> */}
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        {/* Hero Section */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 opacity-10"></div>

          {/* Back Button - integrated into hero */}
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
            <button
              onClick={() => navigate(-1)}
              className="group flex items-center gap-2 bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-white"
            >
              <ArrowLeft className="w-4 h-4 text-teal-600 group-hover:transform group-hover:-translate-x-1 transition-transform" />
              <span className="text-sm font-medium text-gray-700">
                뒤로가기
              </span>
            </button>
          </div>

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="text-center">
              <div className="flex justify-center mb-8">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 blur-xl opacity-50"></div>
                  <Briefcase className="relative w-20 h-20 text-teal-600" />
                </div>
              </div>

              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Virtual Biz Lab
              </h1>

              <p className="text-xl text-gray-600 mb-2">
                AI 가상 비즈니스 실험실
              </p>

              <p className="text-lg text-gray-500 max-w-2xl mx-auto">
                혁신적인 비즈니스 아이디어를 AI와 함께 실험하고 발전시켜보세요
              </p>
            </div>
          </div>
        </div>

        {/* Main Buttons Section */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10">
          <div className="grid md:grid-cols-2 gap-6">
            {/* Business Report Button */}
            <button
              onClick={() => navigate("/vcompany/biz")}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-teal-300"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity"></div>
              <div className="relative">
                <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl mb-4">
                  <FileText className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  비즈니스 레포트
                </h3>
                <p className="text-gray-600">
                  AI가 분석한 상세한 비즈니스 인사이트
                </p>
              </div>
            </button>

            {/* Business Implementation Button */}
            <button
              onClick={() => navigate("/vcompany/realize")}
              className="group relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-8 border border-gray-100 hover:border-cyan-300"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 opacity-0 group-hover:opacity-5 rounded-2xl transition-opacity"></div>
              <div className="relative">
                <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-2xl mb-4">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  비즈니스 실현하기
                </h3>
                <p className="text-gray-600">
                  아이디어를 현실로 만드는 실행 전략
                </p>
              </div>
            </button>
          </div>
        </div>
        {/* Service Limitation Notice */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 pt-10">
          <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6">
            <div className="flex items-start gap-3">
              <AlertCircle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">
                  서비스 제한 사항
                </h4>
                <p className="text-sm text-gray-700">
                  Virtual Biz Lab은 막대한 연산 비용이 소요되므로 현재 출력을
                  제한하고 있습니다. 실제 서비스화 시점보다 결과가 부족할 수
                  있으나, 지속적으로 개선하고 있습니다.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Description Section */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="bg-white rounded-3xl shadow-xl p-10 border border-gray-100">
            <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
              Virtual Biz Lab에서 시작하세요
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="w-14 h-14 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center">
                    <Lightbulb className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  창의적인 아이디어
                </h3>
                <p className="text-gray-600">
                  AI가 당신의 비즈니스 아이디어를 분석하고 발전시켜 드립니다
                </p>
              </div>

              <div className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="w-14 h-14 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center">
                    <Sparkles className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  스마트한 분석
                </h3>
                <p className="text-gray-600">
                  시장 동향과 경쟁사 분석을 통한 전략적 인사이트 제공
                </p>
              </div>

              <div className="text-center">
                <div className="flex justify-center mb-4">
                  <div className="w-14 h-14 bg-gradient-to-r from-teal-500 to-cyan-600 rounded-xl flex items-center justify-center">
                    <Users className="w-7 h-7 text-white" />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  맞춤형 솔루션
                </h3>
                <p className="text-gray-600">
                  당신의 비즈니스에 최적화된 실행 가능한 전략 수립
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* A2A Protocol Innovation Section */}
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 opacity-5 blur-3xl"></div>
            <div className="relative bg-gradient-to-r from-purple-600 to-pink-600 rounded-3xl p-1">
              <div className="bg-white rounded-3xl p-8 md:p-12">
                <div className="flex items-center justify-center mb-6">
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 blur-lg opacity-50"></div>
                    <div className="relative bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-2xl px-6 py-3 font-bold text-lg flex items-center gap-2">
                      <Zap className="w-5 h-5" />
                      혁신 기술
                    </div>
                  </div>
                </div>

                <h3 className="text-4xl font-bold text-center mb-6 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  A2A PROTOCOL
                </h3>

                <p className="text-center text-gray-700 mb-8 text-lg">
                  <span className="font-semibold text-gray-900">Elva팀</span>
                  에서 Google의 A2A 프로토콜을 재해석하여
                  <br />
                  회의에 참여하는 모든 AI가 독립된 인격을 가지고 소통하는
                  <br />
                  <span className="font-bold text-purple-600">
                    차세대 시뮬레이션 엔진
                  </span>
                </p>

                <div className="grid md:grid-cols-3 gap-6 mt-10">
                  <div className="text-center">
                    <div className="flex justify-center mb-3">
                      <Network className="w-10 h-10 text-purple-600" />
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-1">
                      독립된 AI 인격
                    </h4>
                    <p className="text-sm text-gray-600">
                      각 AI가 고유한 관점과 전문성을 보유
                    </p>
                  </div>

                  <div className="text-center">
                    <div className="flex justify-center mb-3">
                      <Cpu className="w-10 h-10 text-pink-600" />
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-1">
                      실시간 상호작용
                    </h4>
                    <p className="text-sm text-gray-600">
                      AI 간 자율적 토론과 협업
                    </p>
                  </div>

                  <div className="text-center">
                    <div className="flex justify-center mb-3">
                      <Sparkles className="w-10 h-10 text-purple-600" />
                    </div>
                    <h4 className="font-semibold text-gray-900 mb-1">
                      창의적 시너지
                    </h4>
                    <p className="text-sm text-gray-600">
                      집단 지성을 통한 혁신적 솔루션
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Legal Notice */}
        <div className="bg-gray-100 border-t border-gray-200">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <p className="text-center text-sm text-gray-600">
              <span className="font-semibold">⚖️ AI 면책 조항</span>
              <br />
              Virtual Biz Lab에서 생성된 비즈니스 아이디어 및 전략에 대한 법률적
              검토와 관련 중요 사항은 반드시 전문가와 함께 다시 한번 검토하시기
              바랍니다.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
